import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  mixins: [userPopMixin],
  name: "user-observed",
  data: function data() {
    return {
      searchForm: {
        pn: 1,
        ps: 20,
        userPhone: "",
        ip: ""
      },
      // 搜索表单

      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      currentObj: {},
      dialogVisible: false,
      remark: ""
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    setIpDialog: function setIpDialog(row) {
      this.currentObj = row;
      this.dialogVisible = true;
    },
    formatIp: function formatIp(ip) {
      if (ip.indexOf(",") > -1) {
        return ip.split(",")[0];
      } else {
        return ip;
      }
    },
    setIpStatus: function setIpStatus() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.setIpStatus({
                ip: _this2.formatIp(_this2.currentObj.ip),
                valid: 1,
                remark: _this2.remark
              });
            case 1:
              _this2.$message.success("操作成功");
              _this2.dialogVisible = false;
              _this2.getIpStatus();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getIpStatus: function getIpStatus() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var ipList, res, blackIpList;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              ipList = [];
              _this3.tableData.forEach(function (item) {
                ipList.push(_this3.formatIp(item.ip));
              });
              _context3.n = 1;
              return _this3.$api.getIpStatus(ipList);
            case 1:
              res = _context3.v;
              blackIpList = [];
              res.data.rows.forEach(function (item) {
                blackIpList.push(item.ip);
              });
              _this3.tableData.forEach(function (item) {
                var itemIp = _this3.formatIp(item.ip);
                if (blackIpList.indexOf(itemIp) > -1) {
                  item.isBlackIp = 1;
                }
              });
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getData: function getData(type) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (type === "search") {
                _this4.searchForm.pn = 1;
              }
              _this4.tableLoading = true;
              _context4.n = 1;
              return _this4.$api.getIpList(_this4.searchForm);
            case 1:
              res = _context4.v;
              res.data.list.forEach(function (item) {
                item.location || (item.location = "");
                item.isBlackIp = 0;
              });
              _this4.tableData = res.data.list;
              _this4.total = res.data.count;
              _this4.tableLoading = false;
              _this4.getIpStatus();
              _this4.getUserListByIds(_this4.tableData, "userId");
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getLocationByIp: function getLocationByIp(row) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this5.$api.getIpInfo({
                ip: row.ip.indexOf(",") > -1 ? row.ip.split(",")[0] : row.ip
              });
            case 1:
              res = _context5.v;
              row.location = res.data.regionName + " " + res.data.city + " " + res.data.district;
              // let res = await this.$api.getLocationByIp({
              //     id: row.id,
              //     ip: row.ip,
              // });
              // row.location = res.data;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    }
  }
};